/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProductType,
} from '../models/index';
import {
    ProductTypeFromJSON,
    ProductTypeToJSON,
} from '../models/index';

/**
 * 
 */
export class ProductTypeResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getProductTypes without sending the request
     */
    async getProductTypesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/products/product-types/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProductTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductType>>> {
        const requestOptions = await this.getProductTypesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductTypeFromJSON));
    }

    /**
     */
    async getProductTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductType>> {
        const response = await this.getProductTypesRaw(initOverrides);
        return await response.value();
    }

}
